import { createAction, props } from '@ngrx/store';

export const customerViewClick = createAction('[Site Layout] Customer View Toggled', props<{ checked: boolean }>());

export const updateAccount = createAction('[Site Layout] Update Account', props<{ accountId: number | null, name: string | null}>());
